import { Input } from '@trackman/web-shared-components';

export const TitleInput = ({ title, setTitle }: { title: string; setTitle: (value: string) => void }) => {
  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.currentTarget.value.length > 80) {
      return;
    }
    setTitle(e.currentTarget.value);
  };

  return (
    <div className='admin-edit-section'>
      <h2>Title*</h2>
      <div className='input-wrapper'>
        <Input label='Title' hint='Max. 80 characters' value={title} onChange={handleTitleChange} />
      </div>
    </div>
  );
};
